export type PlatformProjectId =
  | 'diptol01'
  | 'senfam01'
  | 'laplana01'
  | 'diptdev'
  | 'everestdemo01'
  | 'sierrmcord1'
  | 'dbrefactor2025'
  | 'areaspjccm01'
  | 'ayuntui01'
  | 'canaldcast01'
  | 'sendealgec01';

export const PROJECT_DISPLAY_NAMES: Record<PlatformProjectId, string> = {
  diptol01: 'Senderos de Toledo',
  senfam01: 'Senderos homologados FAM',
  laplana01: 'La Plana',
  diptdev: 'SenToledo DEV',
  everestdemo01: 'Everest Demo',
  sierrmcord1: 'Destino Sierra Morena',
  dbrefactor2025: 'DB Refactor 2025',
  areaspjccm01: 'Áreas Protegidas Castilla-La Mancha',
  ayuntui01: 'Tui',
  canaldcast01: 'Canal de Castilla',
  sendealgec01: 'Senderos de Algeciras'
};

export interface ProjectOption {
  platformId: string; // e.g. 'areaspjccm01'
  projectId: string; // query-api id, e.g. 'AREASPJCCM01'
  displayName: string;
}

export function normalizePlatformId(value: string): string {
  return (value || '').trim().toLowerCase();
}

export function platformIdToProjectId(value: string): string {
  return normalizePlatformId(value).toUpperCase();
}

export function toProjectOption(platformId: string): ProjectOption {
  const normalized = normalizePlatformId(platformId);
  const displayName =
    (PROJECT_DISPLAY_NAMES as any)[normalized] ||
    normalized;

  return {
    platformId: normalized,
    projectId: platformIdToProjectId(normalized),
    displayName
  };
}
